var map = {
	"./1026.jpg": 2487,
	"./13295527_5153829.jpeg": 7090,
	"./13295527_5153829_old.jpg": 8853,
	"./13558745_5283458.png": 6303,
	"./16351572_rm209-adj-20.jpg": 8545,
	"./18246003_v915-wit-001.jpg": 8350,
	"./19256531_6106991.jpg": 267,
	"./2344.jpg": 3013,
	"./24-hour-service.png": 2295,
	"./34012978_black_friday_facebook_banner_02.png": 2097,
	"./4428861.jpg": 3175,
	"./6524364_3306567.jpg": 2945,
	"./6864937_23324.jpg": 8228,
	"./7040910.jpg": 4898,
	"./85333.jpg": 1337,
	"./8767132.jpg": 9063,
	"./Android.png": 7107,
	"./AngularJS.png": 3482,
	"./Azure.png": 9058,
	"./Banner.png": 6321,
	"./Blazor.png": 2040,
	"./Business intelligence.jpg": 9914,
	"./BusinessAnalysis.jpg": 833,
	"./COMMUNICATIONS TECHNOLOGY.jpg": 1088,
	"./CareerBanner.png": 4985,
	"./Cloud (2).jpg": 7676,
	"./Consulting.jpg": 6123,
	"./Data analytics.jpg": 6306,
	"./Datainformation management.jpg": 3739,
	"./Development.jpg": 6411,
	"./DotNet.png": 4714,
	"./Go-Logo_Black.png": 3193,
	"./Go5050.png": 2751,
	"./Gotaste Logo-13.png": 1476,
	"./IBMDL-removebg-preview.png": 1396,
	"./IBMDL_logo_withBG.jpg": 5184,
	"./IBMDL_withBG.jpg": 2376,
	"./Image.png": 7277,
	"./Java.png": 2569,
	"./Kotlin.png": 1792,
	"./Loader.gif": 7238,
	"./Logo-removebg-preview.png": 8013,
	"./Logo-removebg-preview_nobg.png": 3683,
	"./Logo-removebg-preview_old.png": 3438,
	"./Logo-removebg-preview_white.jpg": 3854,
	"./ModinaLogo.png": 8854,
	"./Network_and_cybersecurity.jpg": 4514,
	"./New Products Every Day.gif": 574,
	"./Paw.png": 603,
	"./ProcessFour.png": 149,
	"./ProcessOne.png": 88,
	"./ProcessThree.png": 4291,
	"./ProcessTwo.png": 4827,
	"./ProjectImage.zip": 1256,
	"./ProjectImage/ProjectImage/AdminProjectTurkey/CourseBuyModal.png": 4679,
	"./ProjectImage/ProjectImage/AdminProjectTurkey/CourseSale.png": 4167,
	"./ProjectImage/ProjectImage/AdminProjectTurkey/CourseSetup.png": 2592,
	"./ProjectImage/ProjectImage/AdminProjectTurkey/Customers.png": 7100,
	"./ProjectImage/ProjectImage/AdminProjectTurkey/Dashboard.png": 2051,
	"./ProjectImage/ProjectImage/AdminProjectTurkey/Enrol user management.png": 9501,
	"./ProjectImage/ProjectImage/Go5050/Go5050.jpg": 2564,
	"./ProjectImage/ProjectImage/GoTaste/Admin/CancelationOfOrder.png": 3479,
	"./ProjectImage/ProjectImage/GoTaste/Admin/CreateFoodItem.png": 4615,
	"./ProjectImage/ProjectImage/GoTaste/Admin/DashBoard.png": 391,
	"./ProjectImage/ProjectImage/GoTaste/Admin/FoodItemEdit.png": 2138,
	"./ProjectImage/ProjectImage/GoTaste/Admin/KYCForm.png": 7632,
	"./ProjectImage/ProjectImage/GoTaste/Admin/MenuSetup.png": 15,
	"./ProjectImage/ProjectImage/GoTaste/Admin/OrderManagement.png": 2053,
	"./ProjectImage/ProjectImage/GoTaste/Admin/RestaurantManagement.png": 2119,
	"./ProjectImage/ProjectImage/GoTaste/Admin/RestaurantSetup.png": 1553,
	"./ProjectImage/ProjectImage/GoTaste/Admin/Scheduler.png": 5991,
	"./ProjectImage/ProjectImage/GoTaste/Admin/SectionSetup.png": 1310,
	"./ProjectImage/ProjectImage/GoTaste/Client/CheckOutPage.png": 3450,
	"./ProjectImage/ProjectImage/GoTaste/Client/CreatePost.png": 484,
	"./ProjectImage/ProjectImage/GoTaste/Client/HomePage.png": 9768,
	"./ProjectImage/ProjectImage/GoTaste/Client/Login.png": 5083,
	"./ProjectImage/ProjectImage/GoTaste/Client/PostModal.png": 5087,
	"./ProjectImage/ProjectImage/GoTaste/Client/RestaurantPage.png": 7786,
	"./ProjectImage/ProjectImage/GoTaste/Client/RestaurantSignUp.png": 305,
	"./ProjectImage/ProjectImage/GoTaste/Client/Search.png": 8559,
	"./ProjectImage/ProjectImage/GoTaste/Client/banner.jpg": 9880,
	"./ProjectImage/ProjectImage/Infinigent/BPOFeedBackForm.png": 8979,
	"./ProjectImage/ProjectImage/Infinigent/ClientFeedBackForm.png": 2317,
	"./ProjectImage/ProjectImage/Infinigent/Dashboard.png": 2217,
	"./ProjectImage/ProjectImage/Infinigent/Departments.png": 478,
	"./ProjectImage/ProjectImage/Infinigent/InfinigentFeedBack.png": 2514,
	"./ProjectImage/ProjectImage/Infinigent/Login.png": 663,
	"./ProjectImage/ProjectImage/Infinigent/RolesAndPermissions.png": 959,
	"./ProjectImage/ProjectImage/ModinaFrontend/AdminProject/ClientSetup.png": 345,
	"./ProjectImage/ProjectImage/ModinaFrontend/AdminProject/DesignationSetup.png": 9609,
	"./ProjectImage/ProjectImage/ModinaFrontend/AdminProject/HeroSectionSetup.png": 5937,
	"./ProjectImage/ProjectImage/ModinaFrontend/AdminProject/SocialMediaSetup.png": 8661,
	"./ProjectImage/ProjectImage/ModinaFrontend/HomePage.png": 6355,
	"./ProjectImage/ProjectImage/Pantomime/Admin/BenifitsOfE-Learning.png": 6462,
	"./ProjectImage/ProjectImage/Pantomime/Admin/Designations.png": 9788,
	"./ProjectImage/ProjectImage/Pantomime/Admin/HomePage.png": 3902,
	"./ProjectImage/ProjectImage/Pantomime/Admin/HowWeWork.png": 3965,
	"./ProjectImage/ProjectImage/Pantomime/Client/E-Learning.png": 6102,
	"./ProjectImage/ProjectImage/Pantomime/Client/Home1.png": 3161,
	"./ProjectImage/ProjectImage/Pantomime/Client/Introduction.png": 3888,
	"./ProjectImage/ProjectImage/Pantomime/Client/ServiceProfile.png": 336,
	"./Python.png": 5306,
	"./React.png": 3749,
	"./S1/Free  Square, Beautiful, Science Background Images, Tech Fashion Cool Background Photo Background PNG and Vectors.jpeg": 3941,
	"./S1/WhatsApp Image 2023-10-14 at 18.03.28_6856b413.jpg": 7823,
	"./S1/p2.jpg": 4250,
	"./S1/s2.png": 7003,
	"./S1/s3.png": 393,
	"./SMKW_logo3.png": 5936,
	"./SMKW_logo3_new.png": 9553,
	"./SQL.png": 7690,
	"./Security technology development.jpg": 5200,
	"./Service.png": 2690,
	"./SoftWareArchitecture development.jpg": 7594,
	"./SproutLogo_big-removebg.png": 605,
	"./SproutLogo_big.jpg": 4392,
	"./Systems integration.jpg": 1197,
	"./Web_development.jpg": 7481,
	"./a.png": 3062,
	"./about-us-removebg-preview.png": 7294,
	"./about-us.jpg": 9180,
	"./about_img.webp": 7761,
	"./ai.png": 6871,
	"./algorithm.png": 4616,
	"./analysis.png": 5522,
	"./android-studio-500.png": 7982,
	"./android_dev.png": 8134,
	"./api.png": 9007,
	"./app-development.png": 3075,
	"./apple.png": 5114,
	"./application-secuirity.png": 1537,
	"./application.jpg": 3459,
	"./bank.png": 8429,
	"./blazor_black.png": 2696,
	"./briefcase.png": 2628,
	"./browsing.png": 2316,
	"./business-analysis-old-blue.png": 6505,
	"./business-analysis.png": 5545,
	"./business-analysis_multicolor.png": 9680,
	"./business-intelligence.png": 5743,
	"./businessman.png": 7558,
	"./c-sharp-logo-512.png": 4219,
	"./cardiogram.png": 4913,
	"./career.jpg": 8880,
	"./career2.jpg": 7121,
	"./cash.png": 8362,
	"./change.png": 3214,
	"./character-his-free-time-postponed-work.png": 4172,
	"./clock.png": 3515,
	"./cloud-computing.png": 964,
	"./cloud-server.png": 7423,
	"./cloud.jpg": 1892,
	"./cloud.png": 4455,
	"./cms.png": 5575,
	"./collaboration (1).png": 5474,
	"./collaboration.png": 8296,
	"./communication-technology.png": 7920,
	"./computer.png": 4068,
	"./consulting.png": 7874,
	"./cross-platform (1).png": 5682,
	"./css-3.png": 8498,
	"./custom_app-development.png": 3863,
	"./cybar.jpg": 7706,
	"./cyber-secuirity-threats.png": 8715,
	"./cyber-security.png": 8198,
	"./dark-analytics-concept-illustration.png": 6218,
	"./data-analysis.png": 2309,
	"./data-information-management.png": 708,
	"./data-security.png": 1952,
	"./data_security.jpg": 9551,
	"./deployment.png": 7498,
	"./design.png": 1977,
	"./development-lifecycle.gif": 3690,
	"./development-web-mobile.png": 924,
	"./dollar.png": 7847,
	"./double-quotes-background.png": 8833,
	"./double-quotes.png": 1549,
	"./down-arrow.png": 1233,
	"./e-commerce.png": 6201,
	"./ecommerce.png": 3569,
	"./education-system-blue.png": 685,
	"./education-system.png": 7627,
	"./education.png": 5795,
	"./email-security-cloud security.png": 6421,
	"./email.png": 928,
	"./engage-logo.png": 235,
	"./estimate.png": 7654,
	"./facebook.png": 3639,
	"./favicon.ico": 9315,
	"./favicon.ico.ico": 4978,
	"./favorites.png": 8326,
	"./feature-selection.png": 8280,
	"./feedback.gif": 9611,
	"./flat-design-benchmark-illustration.png": 4562,
	"./flow-chart.png": 369,
	"./food-delivery.png": 2358,
	"./go5050logo2 1.png": 2400,
	"./hack.jpg": 193,
	"./hand-drawn-flat-design-rpa-illustration.png": 610,
	"./hashtag.png": 1271,
	"./hms.png": 3539,
	"./home_bg.png": 7986,
	"./hotel-management.png": 7981,
	"./idea.png": 8188,
	"./image001.png": 6801,
	"./img1.jpg": 6109,
	"./img2.jpg": 5061,
	"./img3.jpg": 4355,
	"./img4.jpg": 4457,
	"./img5.jpg": 4975,
	"./img6.jpg": 5127,
	"./infastructure.jpg": 3507,
	"./infrastructure-security.png": 5918,
	"./infrastructure.png": 7196,
	"./instagram.png": 8483,
	"./insurance.png": 5954,
	"./inventory.png": 6910,
	"./java (1).png": 9548,
	"./java-script.png": 6669,
	"./joinTeam.png": 7465,
	"./js (1).png": 7668,
	"./js.png": 491,
	"./knowledge.png": 3395,
	"./laptop.png": 4086,
	"./linkedin.png": 6769,
	"./location-icon.png": 5617,
	"./location-pin.png": 7143,
	"./logo (1).png": 1772,
	"./logo.png": 5051,
	"./maintenance.png": 4022,
	"./map.png": 4054,
	"./miscellaneous.png": 6821,
	"./mobile.png": 9986,
	"./mobile_development.png": 1493,
	"./monitor.png": 8916,
	"./ms-sql-server-filled.png": 3538,
	"./ms-sql-server.png": 5697,
	"./my-sql-filled.png": 2748,
	"./navite.svg": 512,
	"./network-cyber-security.png": 4720,
	"./network_-_45961 (360p).mp4": 8660,
	"./office.png": 4916,
	"./offshore-technology.png": 8499,
	"./online-shop.png": 3674,
	"./organizational.png": 3581,
	"./outsourcing.jpg": 8939,
	"./outsourcing.png": 5208,
	"./pacakage-implementation.png": 9382,
	"./package.jpg": 2985,
	"./people-starting-business-project-illustration.png": 5643,
	"./pos-system.png": 2004,
	"./process-development.jpg": 4378,
	"./programming.png": 6757,
	"./project-delivery.png": 7108,
	"./projectDelivery.jpg": 3534,
	"./quality-assurance.png": 6043,
	"./rhti-logo.png": 7161,
	"./right-arrow.png": 6611,
	"./risk.png": 7204,
	"./rpa.png": 3548,
	"./saas (1).png": 8024,
	"./saas.png": 8466,
	"./sand-timer.png": 7065,
	"./sdlc.png": 6158,
	"./security-technology-development.png": 8542,
	"./selective.png": 3907,
	"./smartphone.png": 7591,
	"./social-media.png": 7704,
	"./software-application-programming-developer-technology-concept.jpg": 9971,
	"./solution.png": 7331,
	"./sproutLogo (1).png": 4868,
	"./sproutLogo (2).png.crdownload": 8131,
	"./sproutLogo.png": 3610,
	"./sq-lite-filled.png": 3143,
	"./sq-lite.png": 2434,
	"./sql-server-black-white.png": 5420,
	"./supply-chain.png": 3255,
	"./system-integration.png": 1198,
	"./target.png": 9771,
	"./task-management.png": 1046,
	"./team.png": 8503,
	"./team2.png": 1331,
	"./team3.png": 1057,
	"./team4.png": 1243,
	"./team5.png": 5452,
	"./team6.png": 2639,
	"./team7.png": 7047,
	"./technology.png": 6297,
	"./telecommunications.png": 8767,
	"./telephone.png": 8576,
	"./time-management.png": 1806,
	"./twitter.png": 8019,
	"./typescript.png": 4430,
	"./ui.png": 4218,
	"./umbrella.png": 7398,
	"./upgrade.png": 2647,
	"./web-development-new.png": 9164,
	"./web-development.png": 9637,
	"./website.png": 4020,
	"./whoweare.jpg": 2899,
	"./whoweare.png": 4011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9536;